import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import DropdownSelectorInput from "src/shared/v-components/ui/form/DropdownSelectorInput.vue";
import NotificationEllipsis from "src/shared/v-components/ui/NotificationEllipsis.vue";
import { useClientKeys } from "src/shared/store/client-key/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ClientKeyComponentVariableBuiltValue',
    props: {
        value: {}
    },
    setup(__props) {
        const props = __props;
        const { clientKeys, primer } = useClientKeys();
        const isStringList = (value) => {
            return (Array.isArray(value) && value.every((item) => typeof item === "string"));
        };
        const valueProxy = computed(() => {
            return isStringList(props.value) ? props.value : [];
        });
        const clientKeyOptions = computed(() => {
            return clientKeys.value.map((clientKey) => {
                return {
                    displayName: clientKey.name,
                    value: clientKey.id,
                };
            });
        });
        return (_ctx, _cache) => {
            return (_unref(primer).isLoading)
                ? (_openBlock(), _createBlock(NotificationEllipsis, { key: 0 }))
                : (_openBlock(), _createBlock(DropdownSelectorInput, {
                    key: 1,
                    modelValue: valueProxy.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((valueProxy).value = $event)),
                    options: clientKeyOptions.value,
                    prompt: 'Client Key'
                }, null, 8 /* PROPS */, ["modelValue", "options"]));
        };
    }
});
